import React from 'react'
import { isMobileView } from '../../Common/utils';

export default function ListingBody(props) {

    const { content, src_dump, moveToFunnel, showAllBuses = false, showClientContent } = props;
    const mobileView = isMobileView();

    return (
        <>
            {content.map((list, index) => {
                if ((+index < 9 && !showAllBuses) || showAllBuses) {
                    const { src, dest, url } = list;
                    const cardName = `${src} to ${dest} Bus`

                    return (
                        <tr key={index + "operatorListingBody"} className="seoListingTable operatorsTable"
                            onClick={() => {
                                if (mobileView) {
                                    moveToFunnel({ page: 'srp', data: list })
                                }
                            }}
                        >
                            <td>
                                <div className="travellerInfoSection">
                                    <div className="travellerName">
                                        <p className="travelAgency truncatelistHeading width300">
                                            {url ? <a className="interlinkcardHeading" href={url}>{cardName}</a> : <>{cardName}</>}
                                        </p>
                                        <p className="busDuration">
                                            {list.duration} (appx.)
                                        </p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p className="busTypeInfo"
                                    style={{
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: 2,
                                        overflow: 'hidden',
                                        display: '-webkit-box'
                                    }}>{list.operators && list.operators.length ? list.operators.join(',') : ''}</p>
                            </td>
                            <td>
                                {!src_dump ? <>
                                    <p className="price"> {`₹ ${list.min_fare}`}</p>
                                    <p className="orgPrice lineThrough">onwards</p>
                                </> : null}
                            </td>
                            <td>
                                {showClientContent ? <span
                                    className="selectSeat cpointer"
                                    onClick={() => { moveToFunnel({ page: 'srp', data: list }); }}>
                                    VIEW BUSES
                                </span> : <></>}
                                <p className="seatLeft">{list.buses_count} buses</p>
                                <div className="mobileOnly">
                                    {!src_dump ? <>
                                        <p className="listingPrice" style={{ fontWeight: 700 }}>{`₹ ${list.min_fare}`}</p>
                                        <p className="orgPrice lineThrough">onwards</p>
                                    </> : <></>}
                                </div>
                            </td>
                        </tr>
                    )
                }
            })}
        </>
    )
}
